import { Paper, Typography } from "@mui/material";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    ResponsiveContainer,
    Tooltip,
    CartesianGrid,
} from "recharts";

export default function ChartBar({ title, data }) {
    return (
        <Paper sx={{ p: 3, borderRadius: 3, height: 320 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                {title}
            </Typography>

            <ResponsiveContainer width="100%" height="85%">
                <BarChart data={data}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                    <Tooltip />
                    <Bar dataKey="value" fill="#1c64f2" radius={[6, 6, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </Paper>
    );
}
